import { Button } from '@mui/material';
import { FC } from 'react';

type SubmitButtonProps = {
  text?: string;
};

export const SubmitButton: FC<SubmitButtonProps> = ({ text }) => {
  return (
    <Button variant="contained" color="primary" type="submit" size="large">
      {text || 'Submit'}
    </Button>
  );
};
